export * from './customer.model';
export * from './article.model';
export * from './invoice.model';
export * from './search.model';
export * from './pack.model';
export * from './serv.model';
export * from './postit.model';
export * from './sms.model';
export * from './marketing.model';
export * from './bike.model';
export * from './postural.model';
export * from './order.model';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/models/index.ts